import React from 'react';
import PropTypes from 'prop-types';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';

const WARNING_TYPE = {
	DANGER: 'danger', // Exclamation point
	NO_WARNING: 'no_warning', // Check mark
};

const VARIANT = {
	DANGER: {
		warningType: WARNING_TYPE.DANGER,
		color: '#DB0900',
	},
	WARNING: {
		warningType: WARNING_TYPE.DANGER,
		color: '#ECBD00',
	},
	NO_WARNING: {
		warningType: WARNING_TYPE.NO_WARNING,
		color: '#42A04B',
	},
};

export const WarningIcon = ({variant, ...props}) => {
	const {warningType, color} = variant;
	return (
		<BaseIcon {...props} overrideColor={false}>
			{warningType === WARNING_TYPE.NO_WARNING ? (
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect
						x="2.34521"
						y="9.99927"
						width="11.25"
						height="11.25"
						transform="rotate(-45 2.34521 9.99927)"
						fill={color}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M17.4145 9.52855L10.7715 2.88557C10.5112 2.62522 10.0891 2.62522 9.82872 2.88557L3.18574 9.52855C2.92539 9.7889 2.92539 10.211 3.18574 10.4714L9.82872 17.1143C10.0891 17.3747 10.5112 17.3747 10.7715 17.1143L17.4145 10.4714C17.6748 10.211 17.6748 9.78889 17.4145 9.52855ZM11.4786 2.17846C10.8278 1.52759 9.77248 1.52759 9.12161 2.17846L2.47863 8.82144C1.82776 9.47231 1.82776 10.5276 2.47863 11.1785L9.12161 17.8214C9.77248 18.4723 10.8278 18.4723 11.4786 17.8214L18.1216 11.1785C18.7725 10.5276 18.7725 9.47231 18.1216 8.82144L11.4786 2.17846Z"
						fill={color}
					/>
					<rect
						x="6.31519"
						y="10.2258"
						width="1.2"
						height="4.46314"
						rx="0.6"
						transform="rotate(-45 6.31519 10.2258)"
						fill="white"
					/>
					<rect
						x="13.4363"
						y="7.80005"
						width="1.2"
						height="6.69472"
						rx="0.6"
						transform="rotate(45 13.4363 7.80005)"
						fill="white"
					/>
				</svg>
			) : (
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect
						x="2.04517"
						y="10.3788"
						width="11.25"
						height="11.25"
						transform="rotate(-45 2.04517 10.3788)"
						fill={color}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M17.1145 9.90806L10.4715 3.26509C10.2111 3.00474 9.78902 3.00474 9.52867 3.26509L2.88569 9.90806C2.62534 10.1684 2.62534 10.5905 2.88569 10.8509L9.52867 17.4938C9.78902 17.7542 10.2111 17.7542 10.4715 17.4938L17.1145 10.8509C17.3748 10.5905 17.3748 10.1684 17.1145 9.90806ZM11.1786 2.55798C10.5277 1.90711 9.47243 1.90711 8.82156 2.55798L2.17859 9.20096C1.52771 9.85183 1.52771 10.9071 2.17859 11.558L8.82156 18.2009C9.47244 18.8518 10.5277 18.8518 11.1786 18.2009L17.8216 11.558C18.4724 10.9071 18.4724 9.85183 17.8216 9.20095L11.1786 2.55798Z"
						fill={color}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.90001 5.87842C10.2314 5.87842 10.5 6.16624 10.5 6.52128V10.807C10.5 11.162 10.2314 11.4498 9.90001 11.4498C9.56864 11.4498 9.30001 11.162 9.30001 10.807V6.52128C9.30001 6.16624 9.56864 5.87842 9.90001 5.87842Z"
						fill="white"
					/>
					<path
						d="M10.8 13.9141C10.8 14.4467 10.3971 14.8784 9.9 14.8784C9.40294 14.8784 9 14.4467 9 13.9141C9 13.3816 9.40294 12.9498 9.9 12.9498C10.3971 12.9498 10.8 13.3816 10.8 13.9141Z"
						fill="white"
					/>
				</svg>
			)}
		</BaseIcon>
	);
};

WarningIcon.propTypes = {
	variant: PropTypes.oneOf(Object.values(VARIANT)),
	...iconPropTypes,
};
WarningIcon.defaultProps = {
	variant: VARIANT.DANGER,
	...iconDefaultProps,
};

WarningIcon.VARIANT = VARIANT;
